import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import TeamList from "./TeamList";
import * as teamThunks from "../../redux/thunks/teamThunks";
import teamActions from "../../redux/reducers/teamReducer/teamActions";
import fileDownloader from "../../utils/functions/fileDownloader";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "../../constants/defaultsPages";

const TeamListContainer = ({
  loadAllTeams,
  clearAllTeams,
  deleteTeam,
  teams,
  organizers,
  loading,
  match,
  archiveTeam,
}) => {
  console.log("teams", teams);
  const organizerId = match.params.organizerId;
  const organizer = organizers.find(
    (organizer) => organizer.id === organizerId
  );
  const fileName = `${organizer ? `${organizer.name}_` : ""}equipos.csv`;

  useEffect(() => {
    clearAllTeams();
    loadAllTeams(organizerId, DEFAULT_PAGE, DEFAULT_PAGE_SIZE);
  }, [organizerId]);

  const onRefreshUsers = (page, pageSize) => {
    clearAllTeams();
    loadAllTeams(organizerId, page, pageSize);
  };

  const deleteTeamHandler = (teamId) => deleteTeam(organizerId, teamId);

  const downloadHandler = async () =>
    await fileDownloader(`/organizers/${organizerId}/teams/csv`, fileName);

  const archiveTeamHandler = (teamId, archived) =>
    archiveTeam(organizerId, teamId, archived);

  return (
    <TeamList
      deleteTeam={deleteTeamHandler}
      teams={teams}
      loadingFetchTeams={loading.loadAllTeams}
      loadingDeleteTeam={loading.deleteTeam}
      downloadHandler={downloadHandler}
      loadAllTeams={loadAllTeams}
      defaultPage={DEFAULT_PAGE}
      defaultPageSize={DEFAULT_PAGE_SIZE}
      organizerId={organizerId}
      onRefreshUsers={onRefreshUsers}
      archiveTeam={archiveTeamHandler}
      loadingArchiveTeam={loading.archivingTeam}
    />
  );
};

const mapState = (state) => ({
  organizers: state.organizer.all,
  teams: state.team.all,
  loading: state.loading.team,
});

const mapDispatch = (dispatch) => ({
  loadAllTeams: (organizerId, page, pageSize, name) =>
    dispatch(teamThunks.loadAllTeams(organizerId, page, pageSize, name)),
  clearAllTeams: () => dispatch(teamActions.clearAllTeams()),
  deleteTeam: (organizerId, teamId) =>
    dispatch(teamThunks.deleteTeam(organizerId, teamId)),
  archiveTeam: (organizerId, teamId, archivedValue) =>
    dispatch(teamThunks.archiveTeam(organizerId, teamId, archivedValue)),
});

export default withRouter(connect(mapState, mapDispatch)(TeamListContainer));
